/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_Field_Registry_UrlInputs */



/**
* | output |
* | --- |
* | "Registry URL (optional)" |
*
* @param {Partner_Connectors_Field_Registry_UrlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_field_registry_url = /** @type {((inputs?: Partner_Connectors_Field_Registry_UrlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_Field_Registry_UrlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Registry-URL (optional)")
	return /** @type {LocalizedString} */ ("Registry URL (optional)")
});